<template>
  <el-tabs tab-position="left" v-model="active">
    <el-tab-pane label="准入申请" name='apply'>
      <platform-apply v-if="active==='apply'" @changeTab="changeTab"></platform-apply>
    </el-tab-pane>
    <el-tab-pane label="平台列表" name='list'>
      <platform-list v-if="active==='list'"></platform-list>
    </el-tab-pane>
  </el-tabs>

</template>
<script>
import platformApply from './platformApply.vue';
import platformList from './platformList.vue';
export default {
  components: {
    platformApply,
    platformList
  },
  data () {
    return {
      active: "apply"
    }
  },
  methods: {
    // 改变tab选项
    changeTab (active) {
      this.active = active;
    }
  }
}
</script>

